import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SidebarLayout from "../../components/sidebarLayout";
import menuData from "../../data/menuData"; // 메뉴 데이터 가져오기
import "./terms.css";

export default function Terms() {
  const memberMenu = menuData.find((menu) => menu.title === "회원안내");

  return (
    <div>
      <SidebarLayout menu={memberMenu}>
        <Container className="my-5">
          <Row className="mb-4">
            <Col>
              <h5>제 1 조 (목적)</h5>
              <p>
                이 약관은 (사)한국관광산업포럼 사이트에서 제공하는 인터넷 관련
                서비스(이하 서비스라 합니다)를 이용함에 있어
                (사)한국관광산업포럼과 이용자의 권리, 의무 및 책임사항을
                규정함을 목적으로 합니다.
              </p>

              <h5>제 2 조 (정의)</h5>
              <ul>
                <li>
                  (사)한국관광산업포럼 사이트란 컴퓨터 등 정보통신설비를
                  이용하여 컨텐츠 서비스를 제공하는 가상의 공간을 말하며, 아울러
                  서비스를 제공하는 사업자의 의미로도 사용합니다.
                </li>
                <li>
                  이용자란 (사)한국관광산업포럼 사이트에 접속하여 이 약관에 따라
                  서비스를 받는 자를 말합니다.
                </li>
                <li>
                  회원이라 함은 (사)한국관광산업포럼 사이트에 개인정보를
                  제공하여 회원등록을 한 자로서, (사)한국관광산업포럼 사이트의
                  정보를 지속적으로 제공받으며, 서비스를 계속적으로 이용할 수
                  있는 자를 말합니다.
                </li>
                <li>
                  비회원이라 함은 회원에 가입하지 않고 서비스를 이용하는 자를
                  말합니다.
                </li>
              </ul>

              <h5>제 3 조 (약관의 효력 및 변경)</h5>
              <p>
                1. 이 약관은 (사)한국관광산업포럼 사이트를 통하여 이를
                공지하거나 전자우편 기타의 방법으로 회원에게 통지함으로써 효력이
                발생됩니다.
              </p>
              <p>
                2. (사)한국관광산업포럼은 사정상 중요한 사유가 발생될 경우 사전
                고지 없이 이 약관의 내용을 변경할 수 있으며 변경된 약관은
                제1항과 같은 방법으로 공지 또는 통지함으로써 효력이 발생됩니다.
              </p>
              <p>
                3. 회원은 변경된 약관에 동의하지 않을 경우 회원 탈퇴를 요청할 수
                있으며, 변경된 약관의 효력 발생일 이후에도 서비스를 계속 사용할
                경우 약관의 변경 사항에 동의한 것으로 간주됩니다.
              </p>

              <h5>제 4 조 (약관의 공지 및 준칙)</h5>
              <p>
                본 약관에 명시되지 아니한 사항에 대해서는 전기통신기본법,
                전기통신사업법, 정보통신망 이용촉진 등에 관한 법률 및 기타 관련
                법령의 규정에 따릅니다.
              </p>

              <h5>제 5 조 (이용 신청)</h5>
              <ul>
                <li>
                  회원으로 가입하여 서비스를 이용하기를 희망하는 자는
                  (사)한국관광산업포럼이 요청하는 소정의 가입신청 양식에서
                  요구하는 사항을 기록하여 신청합니다.
                </li>
                <li>
                  온라인 가입신청 양식에 기재하는 모든 회원 정보는 실제 데이터인
                  것으로 간주하며 실명이나 실제 정보를 입력하지 않은 사용자는
                  법적인 보호를 받을 수 없으며, 서비스 사용의 제한을 받을 수
                  있습니다.
                </li>
              </ul>

              <h5>제 6 조 (인터넷에서의 개인정보 보호)</h5>
              <p>
                (사)한국관광산업포럼은 인터넷에서의 개인정보 보호를 매우
                중요하게 생각하고 회원이 서비스를 이용함에 있어서 온라인상에서
                (사)한국관광산업포럼에게 제공한 개인정보가 보호받을 수 있도록
                최선을 다하고 있습니다.
              </p>
              <p>
                통신비밀보호법, 전기통신사업법, 정보통신망이용촉진 등에 관한
                법률 등 정보통신 서비스 제공자가 준수하여야 할 관련 법규를
                바탕으로 개인정보 보호정책을 만들어 이를 준수하고 있습니다.
              </p>

              <h5>제 7 조 (개인정보의 보호)</h5>
              <p>
                (사)한국관광산업포럼은 개인정보 보호에 최선을 다하며, 회원이
                서비스를 이용하면서 제공한 개인정보를 안전하게 관리합니다.
              </p>
              <p>
                회원의 개인정보는 서비스 제공 및 개선을 목적으로 사용되며,
                회원의 동의 없이는 외부에 제공되지 않습니다. 자세한 사항은
                개인정보 보호정책을 참고하십시오.
              </p>

              <h5>제 8 조 (이용 신청의 승낙)</h5>
              <ul>
                <li>
                  (사)한국관광산업포럼은 이용 신청에 대해 특별한 사정이 없는 한
                  접수 순서대로 이용 신청을 승낙합니다.
                </li>
                <li>
                  다음 각 호에 해당하는 경우 이용 신청에 대한 승낙을 제한하거나
                  거절할 수 있습니다:
                  <ul>
                    <li>서비스 관련 설비가 부족한 경우</li>
                    <li>기술적 문제가 있는 경우</li>
                    <li>허위 정보를 기재한 경우</li>
                  </ul>
                </li>
              </ul>

              <h5>제 9 조 (계약 사항의 변경)</h5>
              <p>
                회원은 개인정보의 변경사항이 있을 경우 즉시 온라인으로 수정을
                요청해야 합니다. 변경하지 않아 발생한 문제의 책임은 회원에게
                있습니다.
              </p>

              <h5>제 10 조 ((사)한국관광산업포럼의 의무)</h5>
              <ul>
                <li>
                  (사)한국관광산업포럼은 회원이 안정적으로 서비스를 이용할 수
                  있도록 최선을 다합니다.
                </li>
                <li>
                  회원의 의견이나 불만사항이 접수된 경우, 이를 신속히 처리해야
                  합니다.
                </li>
              </ul>

              <h5>제 11 조 (회원의 의무)</h5>
              <ul>
                <li>
                  회원은 본 약관 및 서비스 이용에 관한 공지사항을 준수해야 하며,
                  이를 위반하여 발생한 결과에 대해 책임을 집니다.
                </li>
                <li>
                  회원은 ID와 비밀번호를 안전하게 관리해야 하며, 이를 타인에게
                  공유해서는 안 됩니다.
                </li>
              </ul>

              <h5>제 12 조 (회원의 탈퇴)</h5>
              <p>
                회원은 원장에게 탈퇴서를 제출함으로써 자유롭게 탈퇴할 수 있다.
                이 경우 이미 납부한 회비는 반환하지 아니한다.
              </p>

              <h5>제 13 조 (양도 금지)</h5>
              <p>
                회원은 서비스 이용 권한을 타인에게 양도하거나 담보로 제공할 수
                없습니다.
              </p>

              <h5>제 14 조 (서비스 이용 범위)</h5>
              <p>
                회원은 (사)한국관광산업포럼 사이트의 서비스를 통해 제공되는 모든
                콘텐츠와 기능을 이용할 수 있습니다.
              </p>

              <h5>제 15 조 (정보의 제공)</h5>
              <p>
                (사)한국관광산업포럼은 회원이 서비스 이용 중 필요하다고 인정되는
                다양한 정보를 공지사항이나 전자우편 등의 방법으로 회원에게
                제공할 수 있습니다.
              </p>

              <h5>제 16 조 (요금)</h5>
              <p>
                (사)한국관광산업포럼이 제공하는 서비스는 기본적으로 무료입니다.
                단, 특정 유료 서비스의 경우 사전에 명시된 요금을 지불해야 이용할
                수 있습니다.
              </p>

              <h5>제 17 조 (회원의 게시물)</h5>
              <ul>
                <li>
                  (사)한국관광산업포럼은 회원이 게시하거나 등록한 내용물이 다음
                  각 호에 해당한다고 판단될 경우, 사전 통지 없이 삭제할 수
                  있습니다:
                  <ul>
                    <li>
                      다른 회원 또는 제3자를 비방하거나 명예를 손상시키는 경우
                    </li>
                    <li>공공질서 및 미풍양속에 위반되는 경우</li>
                    <li>범죄 행위와 관련된 내용인 경우</li>
                    <li>
                      (사)한국관광산업포럼 또는 제3자의 저작권을 침해하는 경우
                    </li>
                    <li>게시판의 성격에 부합하지 않는 게시물인 경우</li>
                    <li>기타 관련 법령에 위배되는 경우</li>
                  </ul>
                </li>
              </ul>

              <h5>제 18 조 (게시물의 저작권)</h5>
              <ul>
                <li>
                  회원이 서비스에 게시한 콘텐츠의 저작권은 게시자 본인에게
                  있습니다. 단, (사)한국관광산업포럼은 비영리적 목적으로 해당
                  게시물을 활용할 수 있습니다.
                </li>
                <li>
                  회원은 서비스 내의 자료를 허가 없이 가공하거나 상업적으로
                  사용할 수 없습니다.
                </li>
              </ul>

              <h5>제 19 조 (광고 게재 및 광고주와의 거래)</h5>
              <ul>
                <li>
                  (사)한국관광산업포럼은 서비스 운영과 관련하여 광고를 게재할 수
                  있으며, 회원은 서비스 이용 시 광고 게재에 동의한 것으로
                  간주됩니다.
                </li>
                <li>
                  (사)한국관광산업포럼은 회원과 광고주 간의 거래에 대해 어떠한
                  책임도 지지 않습니다.
                </li>
              </ul>

              <h5>제 20 조 (서비스 이용 시간)</h5>
              <p>
                서비스는 연중무휴 24시간 제공됨을 원칙으로 합니다. 단, 정기
                점검이나 기타 불가피한 사유가 발생할 경우 서비스가 일시 중단될
                수 있습니다.
              </p>
              <p>
                (사)한국관광산업포럼은 서비스 중단 시 사전 공지하도록
                노력합니다.
              </p>

              <h5>제 21 조 (서비스 이용 책임)</h5>
              <p>
                회원은 (사)한국관광산업포럼 의 명시적인 허가 없이 서비스를
                이용하여 상업적인 활동을 할 수 없습니다. 이를 위반하여 발생한
                결과에 대해 (사)한국관광산업포럼은 책임지지 않습니다.
              </p>

              <h5>제 22 조 (서비스 제공의 중지 등)</h5>
              <ul>
                <li>
                  (사)한국관광산업포럼은 다음 각 호에 해당하는 경우 서비스
                  제공을 중지할 수 있습니다:
                  <ul>
                    <li>서비스 설비의 보수 등 공사로 인해 부득이한 경우</li>
                    <li>
                      전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를
                      중지한 경우
                    </li>
                    <li>기타 불가항력적 사유가 있는 경우</li>
                  </ul>
                </li>
                <li>
                  (사)한국관광산업포럼은 국가비상사태, 정전, 설비 장애 등으로
                  서비스 이용이 어려운 경우, 이를 제한하거나 중지할 수 있습니다.
                </li>
                <li>서비스 제한 또는 중지 시 회원에게 지체 없이 공지합니다.</li>
              </ul>

              <h5>제 23 조 (계약 해지 및 이용 제한)</h5>
              <ul>
                <li>
                  회원은 언제든지 회원 탈퇴를 요청할 수 있으며,
                  (사)한국관광산업포럼은 이를 즉시 처리합니다.
                </li>
                <li>
                  (사)한국관광산업포럼은 다음 각 호에 해당하는 경우, 사전 통지
                  없이 이용 계약을 해지하거나 서비스를 제한할 수 있습니다:
                  <ul>
                    <li>타인의 개인정보를 도용한 경우</li>
                    <li>서비스 운영을 고의로 방해한 경우</li>
                    <li>공공질서 및 미풍양속에 반하는 행위를 한 경우</li>
                    <li>기타 관련 법령이나 약관을 위반한 경우</li>
                  </ul>
                </li>
              </ul>

              <h5>제 24 조 (손해배상)</h5>
              <p>
                서비스 이용과 관련하여 (사)한국관광산업포럼의 고의 또는 중대한
                과실이 없는 한, 회원에게 발생한 손해에 대해 책임을 지지
                않습니다.
              </p>

              <h5>제 25 조 (면책조항)</h5>
              <ul>
                <li>
                  (사)한국관광산업포럼은 천재지변 등 불가항력으로 인해 서비스를
                  제공할 수 없는 경우, 책임을 면합니다.
                </li>
                <li>
                  회원의 고의나 과실로 인한 서비스 장애에 대해서는 책임을 지지
                  않습니다.
                </li>
                <li>
                  (사)한국관광산업포럼은 회원이 서비스를 이용하며 기대했던
                  이익을 얻지 못한 것에 대해 책임을 지지 않습니다.
                </li>
              </ul>

              <h5>제 26 조 (관할법원)</h5>
              <p>
                서비스 이용으로 발생한 분쟁에 대해 소송이 제기될 경우,
                (사)한국관광산업포럼의 본사 소재지를 관할하는 법원을 전속
                관할법원으로 합니다.
              </p>

              <h5>부칙</h5>
              <p>(시행일) 이 약관은 공시한 날부터 시행합니다.</p>
            </Col>
          </Row>
        </Container>
      </SidebarLayout>
    </div>
  );
}
